import { useEffect } from "react";

import { trackMarketingPageViewed } from "@/lib/marketing-tracking";
import type { MarketingPageKey } from "@/services/marketing-analytics";

type MarketingPageViewOptions = {
  variantId?: string;
  experimentId?: string;
};

// Shared page-view hook keeps public marketing routes on one canonical event schema.
export function useMarketingPageView(pageKey: MarketingPageKey, options: MarketingPageViewOptions = {}) {
  const { experimentId, variantId } = options;

  useEffect(() => {
    trackMarketingPageViewed({ pageKey, experimentId, variantId });
  }, [experimentId, pageKey, variantId]);
}
